import { stringify } from 'query-string';

const apiUrl = process.env.REACT_APP_BACKEND_HOST;

const quizzesProvider = {
  getManyReference: async (params) => {
    const { submissions, ...filter } = params.filter || {};
    const search = [{ $match: { cohort: params.id } }];
    const limit = params.pagination.perPage;
    const page = params.pagination.page;
    const options = {
      method: 'POST',
      body: JSON.stringify(search),
      headers: { 'Content-Type': 'application/json' },
    };
    const query = {
      limit,
      page,
      ...filter,
    };
    const endpoint = submissions
      ? `${apiUrl}/students/search/quizzes/submissions`
      : `${apiUrl}/students/search/quizzes`;
    const url = `${endpoint}?${stringify(query)}`;
    return { url, options };
  },
};

export default quizzesProvider;
